import { useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { IoMenu } from 'react-icons/io5';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { useAuth } from '../../../hooks/useAuth';
import { Logo } from '../../Common/Logo';
import { SidebarDrawer } from '../Drawers/SidebarDrawer';
import { BackContainer, HeaderStyled } from './styles';

// Header is now only used for mobile view
// Desktop uses Sidebar component instead
export const Header = () => {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const { user } = useAuth();

  const openDrawer = () => {
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
  };

  // Page titles for different routes
  const getPageTitle = () => {
    const titles: Record<string, string> = {
      '/arquivos': 'Documentos',
      '/solicitacoes': 'Notas Fiscais',
      '/configuracoes': 'Configurações',
      '/dividas-tributarias': 'Pendências Tributárias',
      '/extrato-bancario': 'Extrato Bancário',
    };
    return titles[location.pathname];
  };

  const pageTitle = getPageTitle();
  const showBackButton = pageTitle && location.pathname !== '/';

  return (
    <HeaderStyled>
      {showBackButton ? (
        <BackContainer>
          <AiOutlineArrowLeft onClick={() => history.push('/')} />
          <span>{pageTitle}</span>
        </BackContainer>
      ) : (
        <Link to="/">
          <Logo tenant light height={28} />
        </Link>
      )}

      <IoMenu onClick={openDrawer} />

      <SidebarDrawer isVisible={isDrawerVisible} onClose={closeDrawer} />
    </HeaderStyled>
  );
};
